"use strict";

exports.__esModule = true;
exports.UsersScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _System = require("../../../System");
var _AppNavbar = require("../../App/AppNavbar");
var _MasterDetailView = require("../../Core/MasterDetailView");
var _Screen = require("../../Core/Screen");
var _Translator = require("../../Core/Translator");
var _CreateUserScreen = require("../CreateUserScreen");
var _UpdateUserScreen = require("../UpdateUserScreen");
var _UserListView = require("../UserListView");
var _UsersToolbar = require("../UsersToolbar/UsersToolbar");
var _class, _UsersScreenComponent;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var UsersScreenComponent = (0, _Translator.withTranslator)(_class = (_UsersScreenComponent = /*#__PURE__*/function (_Component) {
  function UsersScreenComponent() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSelect = function (selected) {
      var _this$props = _this.props,
        history = _this$props.history,
        id = _this$props.match.params.id;
      if (selected === id || selected !== undefined) {
        return;
      }
      history.push((0, _System.getScreenLocation)("UserList"));
    };
    return _this;
  }
  _inheritsLoose(UsersScreenComponent, _Component);
  var _proto = UsersScreenComponent.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      translator = _this$props2.translator,
      id = _this$props2.match.params.id;
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement(_MasterDetailView.MasterDetailView, {
      selected: id,
      onSelect: this.handleSelect,
      renderMaster: function renderMaster() {
        return /*#__PURE__*/_react["default"].createElement(_Screen.Screen, {
          title: translate("UserScreen.title", "Users")
        }, /*#__PURE__*/_react["default"].createElement(_AppNavbar.AppNavbar, {
          title: translate("UserScreen.navbar.title", "Users")
        }), /*#__PURE__*/_react["default"].createElement(_UsersToolbar.UsersToolbar, null), /*#__PURE__*/_react["default"].createElement(_UserListView.UserListView, null));
      },
      renderDetail: function renderDetail() {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.RootRoutes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: (0, _System.getScreenPath)("CreateUser"),
          element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
            component: _CreateUserScreen.CreateUserScreen
          })
        }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
          path: (0, _System.getScreenPath)("UpdateUser"),
          element: /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.CompatRoute, {
            component: _UpdateUserScreen.UpdateUserScreen
          })
        }));
      }
    });
  };
  return UsersScreenComponent;
}(_react.Component), _UsersScreenComponent.defaultProps = {
  translator: undefined
}, _UsersScreenComponent)) || _class;
var UsersScreen = exports.UsersScreen = (0, _reactRouterCompat.withRouter)(UsersScreenComponent);